 import React, { useEffect, useState } from "react";
import { MdOutlineDeleteForever } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import EditMemberPopup from "../Pages/About_Us/EditMemberPopup";
import DeleteMemberPopup from "../Pages/About_Us/DeleteMemberPopup";
import memberImage from "../assest/member.png";
import {updateboardofStudiesPriority, getboardofStudiesPriorityData} from "../controllers/boardofStudiesTable.controller"

import toast from 'react-hot-toast';
import { useDispatch } from "react-redux";
export default function BoardofStudiesTable({
  title,
  editTitle,
  MemberData,
  handleDeleteConfirm,
  deletePopup,
  setDeletePopup,
  closeDeletePopup,
  loading,
  fetchMembers,
  updateMember
}) {

 // console.log('mem da => ', MemberData)
 const dispatch = useDispatch()
  const [editPopup, setEditPopup] = useState({ isOpen: false, data: null });
  const [priorityData, setPriorityData] = useState([]);
  const handleEdit = (member) => {
    setEditPopup({ isOpen: true, data: member });
  };


  const fetchTableData = async () => {
    const res = await getboardofStudiesPriorityData()
    console.log('res => ', res)

    if (res.status === 200) {
      const apiData = res?.data?.numbers;

      setPriorityData(apiData)
    }
  }

  useEffect(() => {
    fetchTableData()
  }, [])


  const handleDelete = (member) => {
    setDeletePopup({ isOpen: true, data: member });
  };

  const closeEditPopup = () => setEditPopup({ isOpen: false, data: null });

  const handleEditSubmit = (updatedMember) => {
    // Update logic for edited member (optional)
    closeEditPopup();
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  const handlePriorityChange = async (id, newPriority) => {
    try {
        toast.loading("Updating priority...");
        const response = await updateboardofStudiesPriority({ id, order: newPriority });
        toast.dismiss();
        if (response.status === 200) {
            toast.success("Priority updated successfully!");
            dispatch(fetchMembers())
        } else {
            toast.error("Failed to update priority.");
        }
    } catch (error) {
        console.error("Error updating priority:", error);
        const message = error?.response?.data?.message || "Something went wrong!";
        toast.dismiss();
        toast.error(message);
    }
};


  return (
    <div className="p-4 bg-white border border-gray-300 rounded-lg shadow-md">
      <h2 className="mb-4 text-xl font-semibold text-gray-700">{title}</h2>
      <table className="w-full border border-gray-300 table-auto">
        <thead>
          <tr className="text-left text-gray-600 bg-gray-100">
            <th className="px-4 py-2">PROFILE</th>
            <th className="px-4 py-2">NAME</th>
            <th className="px-4 py-2">DESIGNATION</th>
            <th className="px-4 py-2">PRIORITY</th>
            <th className="px-4 py-2">ACTIONS</th>
          </tr>
        </thead>
        <tbody>
          {MemberData.map((member) => (
            <tr key={member.id} className="border-b border-gray-300">
              <td className="px-4 py-2">
                <img
                  src={member.image_url || memberImage}
                  alt={member.name}
                  className="w-12 h-12 rounded"
                />
              </td>
              <td className="px-4 py-2">{member.name}</td>
              <td className="px-4 py-2">{member.designation}</td>
              <td className="px-4 py-2 text-center">
                <select
                   value={member.bos_order}
                   onChange={(e) => handlePriorityChange(member.id, e.target.value)}
                  className="px-2 py-1 border border-gray-300 rounded-md"
                >
                  {priorityData.map((priority) => (
                    <option key={priority} value={priority}>
                      {priority}
                    </option>
                  ))}
                </select>
              </td>
              <td className="px-4 py-2">
                <div className="flex items-center space-x-4">
                  <button
                    type="button"
                    className="flex items-center px-5 py-1 text-gray-400 bg-gray-100 border border-gray-400 rounded"
                    onClick={() => handleDelete(member)}
                  >
                    Delete
                    <MdOutlineDeleteForever className="w-5 h-5 ml-2" />
                  </button>
                  <button
                    type="button"
                    className="flex items-center px-5 py-1 border rounded text-primary-color border-primary-color bg-primary-color bg-opacity-10"
                    onClick={() => handleEdit(member)}
                  >
                    Edit
                    <FaRegEdit className="w-4 h-4 ml-2" />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Modals */}
      <EditMemberPopup
        title={editTitle}
        isOpen={editPopup.isOpen}
        onClose={closeEditPopup}
        // onSubmit={handleEditSubmit}
        fetchMembers={fetchMembers}
        updateMember={updateMember}
        data={editPopup.data}
      />
      <DeleteMemberPopup
        isOpen={deletePopup.isOpen}
        onClose={closeDeletePopup}
        onConfirm={handleDeleteConfirm}
        data={deletePopup.data}
      />
    </div>
  );
}
